import pageTable from './src/pageTable.vue'

export default pageTable
